import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import BootstrapMenuBar from "./components/menu/BootstrapMenuBar";
import TSExpert from "./components/ts-expert/TSExpert";
import Resume from "./components/resume/Resume";
import LiveList from "./components/LiveList";
import LiveListMatrix from "./components/LiveListMatrix";
import GraphicTopology from "./components/GraphicTopology";
import EventLogOLM from "./components/olm/EventLogOLM";
import OpticFiber from "./components/olm/OpticFiber";
import EventLog from "./components/EventLog";
import Login from "./components/login-config/Login";
import LoginHandler from "./components/login-config/LoginHandler";
import Report from "./components/login-config/Report";
import ChangeLogin from "./components/login-config/ChangeLogin";
import Configuration from "./components/login-config/Configuration";
import EditTags from "./components/login-config/EditTags";
import EditGSD from "./components/login-config/EditGSD";
import Blacklist from "./components/login-config/Blacklist";
import TsExpertConfig from "./components/login-config/TsExpertConfig";
import EthernetConfig from "./components/login-config/EthernetConfig";
import WLANConfig from "./components/login-config/WLANConfig";
import Constants from "./components/utilities/Constants";
import Utils from "./components/utilities/Utils";
import OpticFiberConfig from "./components/login-config/OpticFiberConfig";

const UtilsInstance = new Utils();
class App extends Component {

  retrieveData = async () => {

    let isFiberProcessOn = await fetch(Constants.REQUEST_IP_ADDRESS + "fiber/isFiberProcessOn", { mode: "cors" })
      .then(UtilsInstance.checkStatus)
      .then(res => res.json())
      .then(data => data.isFiberProcessOn)
      .catch((e) => {
        console.log("Request problem: ", e);
        return false;
      });

    let requireReload = false;

    if (sessionStorage.getItem("isFiberProcessOn") === null || String(isFiberProcessOn) !== sessionStorage.getItem("isFiberProcessOn")) {
      requireReload = true;
    }

    sessionStorage.setItem("isFiberProcessOn", isFiberProcessOn);

    if (requireReload) {
      window.location.reload();
    }
  }

  componentDidMount = async () => {
    this.retrieveData();
    if (localStorage.getItem(Constants.LOCAL_STORAGE_KEY) === null) {
      let language = await fetch(Constants.REQUEST_IP_ADDRESS + "language", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.language);

      localStorage.setItem(Constants.LOCAL_STORAGE_KEY, language);
      window.location.reload();
    }
  };

  render() {
    return (
      <Router basename="/monitor-profibus">
        <div className="App">
          <BootstrapMenuBar />
          <div style={mainAppContentStyle}>
            <Switch>
              {/* ------------------ TS Expert------------------ */}
              <Route exact path="/" component={TSExpert} />
              {/* ------------------ Protocol Routes------------------ */}
              <Route path="/resume" component={Resume} />
              <Route exact path="/livelist" component={LiveList} />
              <Route exact path="/livelist/:address" component={LiveList} />
              <Route path="/livelist-matrix" component={LiveListMatrix} />
              <Route path="/graphic-topology" component={GraphicTopology} />
              <Route path="/log" component={EventLog} />
              {/* ------------------ Optic Fiber------------------ */}
              <Route path="/optic-fiber" component={OpticFiber} />
              <Route path="/optic-fiber-log" component={EventLogOLM} />
              {/* ------------------ Config ------------------ */}
              <Route path="/config" component={Configuration} />
              <Route path="/login" component={Login} />
              <Route path="/login-handler" component={LoginHandler} />
              <Route path="/report" component={Report} />
              <Route path="/change-login" component={ChangeLogin} />
              <Route path="/tags" component={EditTags} />
              <Route path="/edit-gsd" component={EditGSD} />
              <Route path="/blacklist" component={Blacklist} />
              <Route path="/ethernet-config" component={EthernetConfig} />
              <Route path="/wlan-config" component={WLANConfig} />
              <Route path="/ts-expert-config" component={TsExpertConfig} />
              <Route path="/optic-fiber-config" component={OpticFiberConfig} />
            </Switch>
          </div>
        </div>
      </Router>
    );
  }
}

// CSS Custom App Margins
const mainAppContentStyle = {
  marginLeft: "24px",
  marginRight: "24px",
};

export default App;
